var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H21C21.8284 3 22.5 3.67157 22.5 4.5H1.5C1.5 3.67157 2.17157 3 3 3ZM24 4.5C24 2.84315 22.6569 1.5 21 1.5H3C1.34315 1.5 0 2.84315 0 4.5V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V4.5ZM1.5 19.5V6H22.5V19.5C22.5 20.3284 21.8284 21 21 21H3C2.17157 21 1.5 20.3284 1.5 19.5Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3H22.5V7.5H1.5V3Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.3C3 18.1343 3.13431 18 3.3 18H10.9969C11.1626 18 11.2969 18.1343 11.2969 18.3V19.2C11.2969 19.3657 11.1626 19.5 10.9969 19.5H3.3C3.13431 19.5 3 19.3657 3 19.2V18.3Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.3C3 15.1343 3.13431 15 3.3 15H10.9969C11.1626 15 11.2969 15.1343 11.2969 15.3V16.2C11.2969 16.3657 11.1626 16.5 10.9969 16.5H3.3C3.13431 16.5 3 16.3657 3 16.2V15.3Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.3C3 12.1343 3.13431 12 3.3 12H10.9969C11.1626 12 11.2969 12.1343 11.2969 12.3V13.2C11.2969 13.3657 11.1626 13.5 10.9969 13.5H3.3C3.13431 13.5 3 13.3657 3 13.2V12.3Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.3C3 9.13431 3.13431 9 3.3 9H10.9969C11.1626 9 11.2969 9.13431 11.2969 9.3V10.2C11.2969 10.3657 11.1626 10.5 10.9969 10.5H3.3C3.13431 10.5 3 10.3657 3 10.2V9.3Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18.3C12.75 18.1343 12.8843 18 13.05 18H20.7469C20.9126 18 21.0469 18.1343 21.0469 18.3V19.2C21.0469 19.3657 20.9126 19.5 20.7469 19.5H13.05C12.8843 19.5 12.75 19.3657 12.75 19.2V18.3Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15.3C12.75 15.1343 12.8843 15 13.05 15H20.7469C20.9126 15 21.0469 15.1343 21.0469 15.3V16.2C21.0469 16.3657 20.9126 16.5 20.7469 16.5H13.05C12.8843 16.5 12.75 16.3657 12.75 16.2V15.3Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.3C12.75 12.1343 12.8843 12 13.05 12H20.7469C20.9126 12 21.0469 12.1343 21.0469 12.3V13.2C21.0469 13.3657 20.9126 13.5 20.7469 13.5H13.05C12.8843 13.5 12.75 13.3657 12.75 13.2V12.3Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.3C12.75 9.13431 12.8843 9 13.05 9H20.7469C20.9126 9 21.0469 9.13431 21.0469 9.3V10.2C21.0469 10.3657 20.9126 10.5 20.7469 10.5H13.05C12.8843 10.5 12.75 10.3657 12.75 10.2V9.3Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyKpi);
export default __webpack_public_path__ + "static/media/my-kpi.a7953f4fecc90ca203ce5000f22f03b4.svg";
export { ForwardRef as ReactComponent };